import React, { useState } from "react";
import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../loader";
import { toast } from "react-toastify";
import { getPortalCD } from "../../utils/helpers";
import {
  allowOnlyAlphabetsSpaceHyphenFirstLetterCapital,
  validateEmail,
} from "../../utils/validation";

import { LOCALE } from "../../utils/constants";
import { ROMANTIC_COMPATIBILITY_ASSESSMENT_ID } from "../../utils/general-config";
import { convertToLowerCase } from "../../utils/utility-functions";

Modal.setAppElement("#root");

const AppModel = ({
  isOpen,
  onRequestClose,
  DownloadAssessmentResultConnect,
  assessmentAttemptId,
  userGUID,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;

  // const dashboardAbTestValue = getCookie("dashboardAbTestValue");
  // const dashboardPath = getDashboardPathByAbTest(
  //   dashboardAbTestValue,
  //   currentLocale,
  // );

  const handleHere = () => {
    setIsLoading(true);
    DownloadAssessmentResultConnect(userGUID, assessmentAttemptId).then(
      (res) => {
        if (res && res.hrefBlobUrl) {
          setIsLoading(false);
          window.open(res.hrefBlobUrl, "_blank");
          // navigate(dashboardPath);
        }
      },
    );
  };

  return (
    <div id="app-model-wrapper">
      <Modal
        id="app-download-modal"
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="Download Notification"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            width: "80%",
            maxWidth: "900px",
            textAlign: "center",
            border: "1px solid black",
            borderRadius: "8px",
            boxShadow: "10px 10px 20px 5px rgba(0, 0, 0, 0.3)",
          },
        }}
      >
        <Loader isLoading={isLoading} />
        {/* Close Icon */}
        <button
          id="app-download-modal-close"
          onClick={onRequestClose}
          className="absolute top-2 right-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-gray-500 hover:text-[#000]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            id="app-download-modal-close-icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={6}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h2
          className="font-bold mb-4 text-[40px]"
          id="app-download-modal-title"
        >
          <span className="text-[#444C5E]">Only Three </span>
          <span className="text-[#805AED]">Simple </span>
          <span className="text-[#444C5E]">Steps</span>
        </h2>
        <p className="text-xl" id="app-download-modal-description">
          <span className="font-normal text-[#444C5E]">
            Your download should begin now.
          </span>
          <span className="font-bold text-[#444C5E]"> You may close</span>
          <span className="font-normal text-[#444C5E]">
            {" "}
            this notification.
          </span>
        </p>
        <p
          className="text-[20px] text-[#444C5E] mt-5"
          id="app-download-modal-fallback-text"
        >
          If the PDF file doesn't start downloading within 15 seconds, please
          click &nbsp;
          <span
            id="app-download-modal-here-link"
            onClick={handleHere}
            className="text-[#805AED] font-bold cursor-pointer"
          >
            here
          </span>
        </p>
      </Modal>
    </div>
  );
};

export default AppModel;
export const CreateNewUserModel = ({
  assessmentAttemptId,
  isOpen,
  setOpen,
  parentId,
  CreateGuestUserConnect,
  GetGuestUserConnect,
  setGuestUserData,
  setGuestUserCount,
  parentEmail,
  guestUserData,
  assessmentId,
  type = "",
  t,
  currentLocale,
  assessmentMapId,
  isPremiumOrGuest,
  id,
  reportType,
  guestUserCount,
  maxSubUserCount,
}) => {
  const isMatchParentAndGuestEmail = (email, parentEmail) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email) && email.includes(parentEmail);
  };
  const isRomanticCompatibilityTest =
    assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);

  const [createGuestUser, setCreateGuestUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const [isCreateUserLoading, setIsCreateUserLoading] = useState(false);

  const resetForm = () => {
    setCreateGuestUser({
      firstName: "",
      lastName: "",
      email: "",
    });
    setError({
      firstName: "",
      lastName: "",
      email: "",
    });
  };

  const handleCloseModal = () => {
    resetForm();
    setOpen(false);
  };

  const validateFirstName = (firstName) => {
    return firstName.trim() === "" ? t("settings.first_name_required") : "";
  };

  const isSendToFriend = type === "send_to_friend";
  const isSendToPartner = type === "send_to_partner";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      const emailError = validateEmail(value, t);
      setError((prevError) => ({ ...prevError, email: emailError }));
    }
    if (name === "firstName") {
      const firstNameError = validateFirstName(value, t);
      setError((prevError) => ({ ...prevError, firstName: firstNameError }));
    }

    setCreateGuestUser((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const { email, firstName, lastName } = createGuestUser;
    const firstNameError = validateFirstName(firstName, t);
    if (firstNameError.length > 0) {
      setError((prevError) => ({ ...prevError, firstName: firstNameError }));
    } else {
      setError((prevError) => ({ ...prevError, firstName: "" }));
    }
    const isEmailError = validateEmail(email.trim(), t);
    if (isEmailError.length > 0) {
      setError((prevError) => ({ ...prevError, email: isEmailError }));
    } else {
      setError((prevError) => ({ ...prevError, emailError: "" }));
    }

    // Check if guest user email already exists
    const isMatchExistingGuestUser = guestUserData.find(
      (item) => item.emailAddress === email.trim(),
    );

    // For send to partner, if email exists in guest list, allow sending
    if (isSendToPartner && isMatchExistingGuestUser) {
      // User exists, proceed with sending to partner
    } else if (isMatchExistingGuestUser) {
      // For other cases, show email already taken error
      setError((prevError) => ({
        ...prevError,
        email: t("settings.email_already_taken"),
      }));
      return; // Exit early if user already exists
    }

    // Check if the guest user email matches the parent's email
    if (isMatchParentAndGuestEmail(email.trim(), parentEmail)) {
      setError((prevError) => ({
        ...prevError,
        email: t("settings.email_already_taken"),
      }));
      return; // Exit early if emails match
    }

    // For send to partner: check guest user count only if email is new

    if (isSendToPartner && !isMatchExistingGuestUser) {
      if (
        isPremiumOrGuest &&
        typeof maxSubUserCount === "number" &&
        maxSubUserCount > 0 &&
        guestUserCount >= maxSubUserCount
      ) {
        toast.warning(t("settings.max_user_reached_msg"));
        return;
      }
    }
    // if (isSendToPartner && !isMatchExistingGuestUser) {
    //   if (isPremiumOrGuest && guestUserCount >= maxSubUserCount) {
    //     toast.warning(t("settings.max_user_reached_msg"));
    //     return; // Exit early if max user count reached for new email
    //   }
    // }

    // if (isSendToPartner && !isMatchExistingGuestUser) {
    //   if (isPremiumOrGuest && guestUserCount >= maxSubUserCount) {
    //     toast.warning(t("settings.max_user_reached_msg"));
    //     return; // Exit early if max user count reached for new email
    //   }
    // }

    if (isEmailError.length > 0 || firstNameError.length > 0) return;
    const guestUserPayload = {
      guestUser: {
        firstName: firstName,
        lastName: lastName,
        emailAddress: email,
        invitationStatus: 0,
      },
      userGuid: parentId,
      locale: currentLocale,
      portalCD: getPortalCD(currentLocale),
    };
    const sendReportPayload = {
      firstName: firstName,
      lastName: lastName,
      emailAddress: email,
      selfUserId: parentId,
      assessmentAttemptId: assessmentAttemptId,
      assessmentId: assessmentId,
      locale: currentLocale,
    };
    const sendReportToFriendPayload = {
      ...sendReportPayload,
      ...(isRomanticCompatibilityTest && {
        resultId: id,
        reportType,
      }),
    };
    const sendReportToPartnerPayload = {
      ...sendReportPayload,
      assessmentMapId: assessmentMapId,
      isPremiumOrGuest: isPremiumOrGuest,
    };

    const payload = isSendToFriend
      ? sendReportToFriendPayload
      : isSendToPartner
        ? sendReportToPartnerPayload
        : guestUserPayload;
    setOpen(false);
    setIsCreateUserLoading(true);
    CreateGuestUserConnect(payload).then((res) => {
      if (isSendToFriend && res) {
        setIsCreateUserLoading(false);
        toast.success(t("settings.report_sent_to_friend_successfully"));
        resetForm();
      } else if (isSendToPartner && res) {
        setIsCreateUserLoading(false);
        toast.success(t("settings.report_sent_to_partner_successfully"));
        resetForm();
      } else {
        if (res === "Success") {
          setIsCreateUserLoading(false);
          toast.success(t("settings.guest_user_created_successfully"));
          setOpen(false);
          resetForm();
          GetGuestUserConnect(parentId).then((res) => {
            if (res) {
              setGuestUserData(res);
              const filteredData = res.filter(
                (item) =>
                  item.invitationStatus === 0 || item.invitationStatus === 1,
              );
              setGuestUserCount(filteredData.length);
            }
          });
        } else if (res === "UserAlreadyExsists") {
          setIsCreateUserLoading(false);
          setCreateGuestUser({
            firstName: "",
            lastName: "",
            email: "",
          });

          // show a toast when user already exists
          toast.warning(t("settings.guest_email_cannot_match_your_email"));

          setError((prevError) => ({
            ...prevError,
            email: t("settings.guest_email_cannot_match_your_email"),
          }));
        }
      }
    });
  };
  const header = {
    send_to_friend: t("settings.send_to_friend"),
    create_guest_user: t("settings.add_new_user_text"),
    send_to_partner: t("settings.send_to_partner"),
  };

  return (
    <>
      <Loader isLoading={isCreateUserLoading} />
      <Modal
        id="create-user-modal"
        isOpen={isOpen}
        contentLabel="Download Notification"
        style={{
          overlay: {
            zIndex: 9999,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            maxWidth: "900px",
            textAlign: "center",
            border: "none",
            background: "transparent",
          },
        }}
      >
        <div
          className="inline-block bg-[#f8f8f8] rounded-lg text-left overflow-hidden shadow-md shadow-insightful-gray transform transition-all sm:my-8 align-middle max-w-2xl w-full"
          id="create-user-modal-container"
        >
          <div
            className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4"
            id="create-user-modal-content"
          >
            <div
              className="flex justify-between items-center"
              id="create-user-modal-header"
            >
              <h3
                className="text-lg leading-6 font-medium text-gray-900"
                id="create-user-modal-title"
              >
                {isSendToFriend
                  ? t("settings.send_to_friend_text")
                  : isSendToPartner
                    ? t("settings.send_to_partner_text")
                    : t("settings.add_new_user_text")}
              </h3>
              <button
                id="create-user-modal-close-button"
                type="button"
                onClick={handleCloseModal}
                className="flex items-center px-2 py-1 rounded-full bg-[#805AED] text-white hover:bg-[#6a4cb8] focus:outline-none"
              >
                <span className="text-xs sm:text-sm mr-1">
                  {t("dashboard.close_button")}
                </span>
                <span className="text-lg sm:text-[24px]">&times;</span>
              </button>
            </div>
            <div className="mt-2" id="create-user-modal-form-wrapper">
              <form
                className="flex flex-col gap-4"
                onSubmit={handleSubmit}
                id="create-user-form"
              >
                <div
                  className="flex justify-between items-center gap-3 w-full"
                  id="create-user-name-fields"
                >
                  <div className="w-full" id="create-user-first-name-wrapper">
                    <label
                      htmlFor="firstName"
                      className="block text-sm font-medium text-gray-700"
                      id="create-user-first-name-label"
                    >
                      {t("settings.first_name")}
                    </label>
                    <input
                      id="create-user-first-name-input"
                      type="text"
                      name="firstName"
                      className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                      onChange={handleInputChange}
                      value={createGuestUser.firstName}
                      maxLength={50}
                      onInput={(e) => {
                        allowOnlyAlphabetsSpaceHyphenFirstLetterCapital(e);
                      }}
                    />
                    {error.firstName && (
                      <div
                        className="text-red-500 text-sm"
                        id="create-user-first-name-error"
                      >
                        {error.firstName}
                      </div>
                    )}
                  </div>
                  <div className="w-full" id="create-user-last-name-wrapper">
                    <label
                      htmlFor="lastName"
                      className="block text-sm font-medium text-gray-700"
                      id="create-user-last-name-label"
                    >
                      {t("settings.last_name")}
                    </label>
                    <input
                      id="create-user-last-name-input"
                      type="text"
                      name="lastName"
                      className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                      onChange={handleInputChange}
                      value={createGuestUser.lastName}
                      maxLength={50}
                      onInput={(e) => {
                        allowOnlyAlphabetsSpaceHyphenFirstLetterCapital(e);
                      }}
                    />
                    {error.firstName && (
                      <div className="text-transparent text-sm">
                        {error.firstName}
                      </div>
                    )}
                  </div>
                </div>
                <div id="create-user-email-wrapper">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                    id="create-user-email-label"
                  >
                    {t("settings.email_address")}
                  </label>
                  <input
                    id="create-user-email-input"
                    type="email"
                    name="email"
                    className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                    onChange={handleInputChange}
                    value={createGuestUser.email}
                  />
                  {error.email && (
                    <div
                      className="text-red-500 text-sm"
                      id="create-user-email-error"
                    >
                      {error.email}
                    </div>
                  )}
                </div>
                <div
                  className="bg-insightful-lightest-gray rounded-lg px-2 lg:px-4 py-2 md:px-6 flex flex-row-reverse items-stretch gap-2"
                  id="create-user-buttons-container"
                >
                  <button
                    className="flex-1 flex items-center justify-center rounded-md border border-transparent shadow-sm px-2 lg:px-4 py-2 bg-blue-600 text-white font-medium hover:bg-blue-700"
                    type="submit"
                  >
                    {isSendToFriend
                      ? t("settings.send_cta")
                      : t("settings.send_invitation")}
                  </button>

                  <button
                    className="flex-1 flex items-center justify-center rounded-md border border-transparent shadow-sm px-2 lg:px-4 py-2 bg-white text-gray-700 font-medium hover:bg-gray-50"
                    onClick={handleCloseModal}
                  >
                    {t("settings.cancel_cta")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
